const LOGO_WHITE = "/brand/MFP_white.svg";

export default function MaintenancePage() {
  return (
    <main
      className="min-h-screen bg-mfp-bg text-white relative overflow-hidden flex items-center justify-center px-6"
      data-testid="maintenance-page"
    >
      {/* Subtle gold glow background */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(60% 50% at 50% 35%, rgba(212,175,55,0.10) 0%, rgba(212,175,55,0) 70%)",
        }}
      />

      <section className="relative max-w-xl w-full text-center flex flex-col items-center gap-8">
        <img
          src={LOGO_WHITE}
          alt="MediaFly Production"
          className="h-10 md:h-12 w-auto opacity-90"
          width="200"
          height="48"
        />

        <div className="space-y-4">
          <div className="text-[10px] md:text-[11px] uppercase tracking-[0.35em] text-mfp-gold font-bold">
            MediaFly Production
          </div>
          <h1 className="font-display text-3xl md:text-5xl uppercase leading-[1.05] text-white">
            Diese Website ist <br className="hidden sm:block" />
            <span className="text-mfp-gold">aktuell nicht erreichbar.</span>
          </h1>
          <p className="text-mfp-champagne/80 text-sm md:text-base leading-relaxed max-w-md mx-auto">
            Wir arbeiten im Hintergrund an der finalen Version.
          </p>
        </div>

        <div className="pt-4">
          <span
            className="inline-block text-[11px] uppercase tracking-[0.3em] text-mfp-gold border border-mfp-gold/40 rounded-full px-5 py-2"
            data-testid="maintenance-coming-soon"
          >
            Coming soon
          </span>
        </div>
      </section>
    </main>
  );
}
